module.exports = __webpack_public_path__ + "static/media/project3.401e673b.png";